import React from "react";
import { Spinner } from "@chakra-ui/react";
import { useHasClarificationsAccess } from "hooks/featureFlags";
import type { Clarification } from "../../types/clarification.type";

import { ClarificationsRegisterProvider, useClarificationsRegisterContext } from "./components/ClarificationsRegisterContext";
import { ClarificationsRegisterHeader } from "./components/ClarificationsRegisterHeader";
import { ClarificationsRegisterToolbar } from "./components/ClarificationsRegisterToolbar";
import { ClarificationsRegisterTable } from "./components/ClarificationsRegisterTable";
import { ClarificationsRegisterModals } from "./components/ClarificationsRegisterModals";

interface SupplierOption {
  id: number;
  name: string;
  logo?: string | null;
}

interface ClarificationsRegisterProps {
  allSuppliers?: SupplierOption[];
  injectedClarifications?: Clarification[];
  isClientView: boolean;
  openSupplierOnClick?: boolean;
  rfxId?: number;
  rfxSubmissionId?: number;
  supplierFilter?: number;
  supplierName: string;
  onDraftCountChange?: (draftCount: number) => void;
  onRowClickOverride?: (clarification: Clarification) => void | null;
}

const ClarificationsRegisterContent: React.FC = () => {
  const { data } = useClarificationsRegisterContext();
  const isClarificationsEnabled = useHasClarificationsAccess();

  if (!isClarificationsEnabled) {
    return null;
  }

  if (data.isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Spinner size="lg" color="blue.500" />
      </div>
    );
  }

  return (
    <div className="rounded-lg bg-white">
      <ClarificationsRegisterHeader />
      <ClarificationsRegisterToolbar />
      <ClarificationsRegisterTable />
      <ClarificationsRegisterModals />
    </div>
  );
};

export const ClarificationsRegister: React.FC<ClarificationsRegisterProps> = (props) => {
  return (
    <ClarificationsRegisterProvider {...props}>
      <ClarificationsRegisterContent />
    </ClarificationsRegisterProvider>
  );
};
